import React from 'react';
import { TInsuranceServer, TInsurance } from 'types/common';
import { getAllInsuranceList, getInsuranceListByOps } from 'api/common';

const globalData: TInsurance[] = [];

const useInsurance = (isOps?: boolean): [TInsurance[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TInsurance[]>(globalData);
    const fetchData = async () => {
        if (loading) return;
        try {
            setLoading(true);
            const result = isOps ? await getInsuranceListByOps() : await getAllInsuranceList();
            if (!result.error) {
                const data: TInsuranceServer[] = result?.data?.data || [];
                const transformedData: TInsurance[] = data.reduce((acc, item) => {
                    // Find the existing state object in the accumulator
                    let stateEntry = acc.find((entry) => entry.state === item.state);

                    if (!stateEntry) {
                        // If no state entry exists, create a new one
                        stateEntry = { state: item.state, carriers: [] };
                        acc.push(stateEntry);
                    }

                    // Add the carrier information to the current state entry
                    stateEntry.carriers.push({
                        name: item.carrier,
                        plans: item.plans,
                    });

                    return acc;
                }, [] as TInsurance[]);
                setItems(transformedData);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useInsurance;
